<template
  ><v-card>
    <v-card-title>
      <span>{{ title }}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="model.typeId"
        :items="activityTypes"
        label="Направление деятельности"
        item-text="name"
        item-value="id"
        clearable
      />
      <v-select
        v-model="model.label"
        :items="ruleTypes"
        label="Тип правила"
        item-text="name"
        item-value="label"
        :readonly="model.id > 0"
      />
      <v-text-field
        type="number"
        v-model="model.index"
        label="Коэффициент"
      ></v-text-field>
      <v-row v-if="model.label === 'points'" align="center">
        <v-col cols="5">
          <v-text-field type="number" v-model="model.data.min"></v-text-field>
        </v-col>
        <v-col cols="2"><span class="text-h6">≤ X &lt;</span></v-col>
        <v-col cols="5">
          <v-text-field type="number" v-model="model.data.max"></v-text-field>
        </v-col>
      </v-row>
      <v-text-field
        type="number"
        v-if="model.label === 'course'"
        v-model="model.data.course"
        label="Курсов до выпуска"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn depressed block @click="save">Сохранить</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "RatingRuleEditor",

  props: {
    value: Object,
    activityTypes: { type: Array, default: () => [] }
  },

  data() {
    return {
      model: {
        data: {}
      },
      ruleTypes: [
        { label: "course", name: "Правило по курсу" },
        { label: "points", name: "Правило по баллам" }
      ]
    };
  },

  computed: {
    title() {
      return this.model.id ? "Редактирование правила" : "Добавление правила";
    }
  },

  watch: {
    value: {
      handler(v) {
        this.model = { ...v };
      },
      immediate: true
    }
  },

  methods: {
    close() {
      this.$emit("close");
    },

    save() {
      this.$emit("input", this.model);
      this.$emit("save", this.model);
      this.close();
    }
  }
};
</script>
